import React from 'react';

import styles from './guidanceCards/GuidanceCard.scss';
import cx from 'classnames';

interface GuidanceModuleProps {
  layout?: 'row' | 'column';
  children: React.ReactNode;
}

const GuidanceModule = ({ children, layout = 'row' }: GuidanceModuleProps) => {
  const classes = cx(styles.guidanceCards, {
    [styles.row]: layout === 'row',
    [styles.column]: layout === 'column',
  });
  return <div className={classes}>{children}</div>;
};

export default GuidanceModule;
